import { Checkbox } from "antd";
import yellodownarrow from "../Assests/Images/yellowuparrow.svg";
import yellouparrow from "../Assests/Images/yellowdownarrow.svg";
import Commontooltip from "./CommonTooltip/Commontooltip";

function CommonArows({
  handleAscending,
  handleDescending,
  Headername,
  Show,
  handleClick,
  isChecked,
  handleFilter,
  type,
  CheckedArray,
  StatusType,
  margintop,
}: {
  handleAscending?: () => void;
  handleDescending?: () => void;
  handleClick?: () => void;
  Headername: string;
  Show: string;
  isChecked?: boolean;
  handleFilter?: () => void;
  type?: string;
  CheckedArray?: any;
  StatusType?: string;
  margintop?: 20 | 0;
}) {
  return (
    <div
      style={{
        width: "90px",
        marginTop: margintop,
        background: "transparent",
        padding: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "11px",
          justifyContent: "space-between",
        }}
      >
        <Commontooltip msg={Headername} placement="top">
          <p
            style={
              Headername.length > 8
                ? {
                    color: "white",
                    width: "60px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: "13px",
                  }
                : {
                    color: "white",
                    fontSize: "14px",
                  }
            }
          >
            {Headername}
          </p>
        </Commontooltip>

        {Show === "ordertype" || Show === "both" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Commontooltip
              children={
                <img
                  src={yellouparrow}
                  style={{ width: "9px" }}
                  onClick={() => {
                    if (handleAscending) handleAscending();
                  }}
                  alt="yellouparrow"
                />
              }
              msg="Ascending"
            />

            <Commontooltip
              children={
                <img
                  src={yellodownarrow}
                  style={{ width: "9px" }}
                  onClick={() => {
                    if (handleDescending) handleDescending();
                  }}
                  alt="yellodownarrow"
                />
              }
              msg="Descending"
              placement="bottom"
            />
          </div>
        ) : null}
      </div>
      {Show === "filter" || Show === "both" ? (
        <div id="ReadingReports">
          <Checkbox
            onChange={() => {
              if (handleFilter) handleFilter();
            }}
            checked={CheckedArray?.includes(type)}
            style={{ marginTop: "10px" }}
            id="checkbosspan"
          >
            {StatusType}
          </Checkbox>
        </div>
      ) : null}
    </div>
  );
}

export default CommonArows;
